import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-sort-caret',
  templateUrl: './sort-caret.component.html',
  styleUrls: ['./sort-caret.component.css']
})
export class SortCaretComponent implements OnInit {
  @Input() currentSort;
  @Input() field;
  constructor() { }

  ngOnInit() {
  }

}
